<template>
  <v-content class="institution page">
    <can I="read" a="Institution">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs class="pl-0"
            :items="[{ exact: true, text: 'Admin', to: '/dashboard' },
                     { exact: true, text: 'Institutions', to: '/institutions' },
                     { exact: true, text: $route.params.id, to: `/institutions/${$route.params.id}` }]">
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <v-btn small flat fab @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <CopyButton />
        </v-toolbar>

        <can I="edit" a="Institution" v-if="editing">
          <Edit @refresh="refresh" @update="update" @cancel="cancel" />
        </can>
        <Show v-else @refresh="refresh" @destroy="destroy" @edit="editing = true" />

        <can I="list" a="QualificationComponent">
          <QualificationComponents :institution="{ id: parseInt($route.params.id) }" />
        </can>
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Components
import Show from '@/components/institutions/Show'
import Edit from '@/components/institutions/Edit'
import QualificationComponents from '@/components/qualification_components/List'

// Vue Component
export default {
  components: {
    Show,
    Edit,
    QualificationComponents
  },
  created() {
    this.$store.dispatch('admin/institutions/fetch', this.$route.params.id)
    this.$store.dispatch('admin/qualificationComponents/fetchAll', { institution: { id: this.$route.params.id } })
  },
  data() {
    return { editing: false }
  },
  computed: {
    institution() { return this.$store.getters['admin/institutions/find'](this.$route.params.id) }
  },
  methods: {
    refresh() {
      this.$store.dispatch('admin/qualificationComponents/fetchAll', { institution: { id: this.$route.params.id } })
      return this.$store.dispatch('admin/institutions/fetch', this.$route.params.id)
    },
    cancel() {
      this.refresh().then(() => (this.editing = false))
    },
    update() {
      this.$store
        .dispatch('admin/institutions/update', {
          id: this.institution.id,
          name: this.institution.name,
          gradeScale: this.institution.gradeScale,
          acronym: this.institution.acronym == '' ? null : this.institution.acronym,
          formerNames: this.institution.formerNames,
        })
        .then(response => {
          if (this.institution.errors) {
            this.$store.commit('snackbar', { text: 'There was a problem updating the institution', type: 'error' })
          } else {
            this.$store.commit('snackbar', { text: 'Institution was updated successfully', type: 'success' })
            this.editing = false
          }
        })
    },
    destroy() {
      this.$store.dispatch('admin/institutions/destroy', this.$route.params.id).then(
        response => {
          // Success
          this.$store.commit('snackbar', { text: 'Institution deleted', type: 'success' })
          this.$router.push('/institutions')
        }
      ).catch(
        error => this.$store.commit('snackbar', { text: 'There was a problem deleting the institution', type: 'error' })
      )
    }
  }
}
</script>
